<template>
<div class="nav-div">
  <nav>
    <dropdown-view v-for="(item, i) in items" :key="i" v-if="item.isAct" :title="item.title" :currentItem="selectedItem" :titleLink="item.link" :items="item.subItems" v-on:clickItem="chooseItem"/>
  </nav>
</div>
</template>

<script>
import Dropdown from './NavbarDropdown'

export default {
  components: {
    'dropdown-view': Dropdown
  },
  data () {
    return {
      selectedItem: '首页',
      items: [
        {
          title: '首页',
          isAct: true,
          link: '/',
          subItems: []
        },
        {
          title: '牛油果直供',
          isAct: true,
          link: '/sggq',
          subItems: []
        },
        {
          title: '牛油果行情',
          isAct: true,
          link: '/sghq/jghq',
          subItems: []
        },
        {
          title: '供应链服务',
          isAct: true,
          link: '/cyfw',
          /* subItems:[{title:'仓储物流服务',link:'/ccwl'},{title:'品牌运营服务',link:'/ppyy'},{title:'云果追溯服务',link:'/ygzs'},{title:'农资服务',link:'/nzfw'},{title:'农机租赁',link:'/njzl'}] */
          // subItems:[{title:'仓储物流服务',link:'/ccwl'},{title:'品牌运营服务',link:'/ppyy'},{title:'农资服务',link:'/nzfw'},{title:'农机租赁',link:'/njzl'}]
          subItems: [{title: '集配中心', link: '/detail/11'}, {title: '分选加工', link: '/detail/9'}, {title: '直播基地', link: '/detail/10'}]
        },
        {
          title: '种植服务',
          isAct: true,
          link: '/jrkjfw',
          subItems: [{title: '种植技术', link: '/zzjs'}]
        },
        {
          title: '行业资讯',
          isAct: true,
          link: '/hyzx',
          // {title:'最新快讯',link:'/02'},
          subItems: [{title: '行业资讯', link: '/01'}, {title: '产业政策', link: '/03'}, {title: '通知公告', link: '/04'}, {title: '行业展会', link: '/05'}]
        },
        /* {
          title: '水果行情',
          isAct:true,
          link: '/sghq',
          subItems:[{title:'价格行情',link:'/jghq'},{title:'每周果情',link:'/mzgq'},{title:'行情分析',link:'/hqfx'}]
        }, */
        // {
        //   title: '精品果园',
        //   isAct: false,
        //   link: '/jpgy',
        //   subItems: []
        // },
        /* {
          title: '专业合作社',
          isAct:true,
          link: '/zyhzs',
          subItems:[]
        }, */
        // {
        //   title: '科技服务',
        //   isAct: true,
        //   link: '/jrkjfw',
        //   /* subItems:[{title:'金融服务',link:'/jrfw'},{title:'科技服务',link:'/kjfw'},{title:'专家服务',link:'/zjfw'},{title:'种植技术',link:'/zzjs'},{title:'加工技术',link:'/jgjs'}] */
        //   subItems: [{title: '科技服务', link: '/kjfw'}, {title: '种植技术', link: '/zzjs'}, {title: '加工技术', link: '/jgjs'}, {title: '专家服务', link: '/zjfw'}]
        // },

        {
          title: '关于牛油果',
          isAct: true,
          link: '/about',
          subItems: [{title: '产业报告', link: '/cybg'}, {title: '牛油果内参', link: '/hync'}, {title: '推介视频', link: '/gynyg'}]
        },
        {
          title: '联系我们',
          isAct: true,
          link: '/lxwm',
          subItems: []
        },
        {
          title: '牛油果SCM',
          isAct: true,
          link: '/SCM',
          subItems: []
        }
      ]
    }
  },
  methods: {
    chooseItem: function (clickedItem) {
      // this.selectedItem=clickedItem.title
      console.log('------回调成功')
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('Navbar路由监听：')
      // console.log("from:"+from.path);//从哪来
      // console.log("to:"+to.path);//到哪去
      let toPath = to.path
      let i = 0, len = this.items.length
      for (i; i < len; i++) {
        // console.log("循环"+i+":导航连接："+this.items[i].link+",匹配："+toPath.indexOf(this.items[i].link));
        if (toPath.indexOf(this.items[i].link) == 0) {
          this.selectedItem = this.items[i].title
        }
      }
    }
  },
  created: function () {
    let currentPath = this.$route.path
    // console.log("主页面开始查询：当前路由："+this.$route.path);
    let i = 0, len = this.items.length
    for (i; i < len; i++) {
      if (currentPath.indexOf(this.items[i].link) == 0) {
        this.selectedItem = this.items[i].title
      }
    }
  }
}
</script>
<style>
.nav-div{
  position:relative;
  height:46px;
  width:100%;
  background-color:  rgb(89,129,24);
}

nav {
  height:46px;
  width:1024px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(89,129,24);
  margin:0px auto;
}

nav .menu-item {
  padding: 0x;
  position: relative;
  z-index:9998;
  height:46px;
  //width:128px;
  width: 100%;
  //width:146.285px;
  font-size:16px;
  color: #FFF;
  text-align: center;
  border-bottom: 0px solid transparent;
  transition: 0.4s;
}

nav .menu-item a{
  font-size:14px;
  color: #FFF;
  line-height:46px;
}

nav .menu-item.active,
nav .menu-item:hover {
  background-color: #f1a100;
  border-bottom-color: #FF5858;
}

nav .menu-item a {
  display:block;
  color: inherit;
  text-align: center;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SiteNavbar.vue